var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
    'm-switch',
    'm-switch-' + _vm.type,
    {
      active: _vm.booleanVal,
      'is-disabled': _vm.disabled,
      'is-small': _vm.small
    }
  ],on:{"touchend":function($event){$event.preventDefault();return _vm.change.apply(null, arguments)},"mouseup":function($event){$event.preventDefault();return _vm.change.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }